export interface QuizPhotoQuestionCopy {
  subText: string;
  title: string;
}

export interface QuizPhotoQuestionCopyByGender {
  female: QuizPhotoQuestionCopy;
  male: QuizPhotoQuestionCopy;
}

/**
 * Fixed copy for the hair photo questions, used instead of the tree's own title/subtitle while
 * `skipPhotoInstructions` is on. A function, not a constant, so `$localize` runs after
 * `loadTranslations` — see client/app/consultation-quiz/CLAUDE.md.
 */
export function getQuizPhotoQuestionCopy(): Readonly<Record<string, QuizPhotoQuestionCopyByGender>> {
  return {
    HairfallPhotoTop: {
      female: {
        title: $localize`:@@quizHairTopPhotoTitleFemale:Lets analyze your partition width`,
        subText: $localize`:@@quizHairTopPhotoSubTextFemale:Take a top photo with centre hair partition. Doctor will check this photo to assess your hair density.`,
      },
      male: {
        title: $localize`:@@quizHairTopPhotoTitleMale:Lets analyze your hair density`,
        subText: $localize`:@@quizHairTopPhotoSubTextMale:Take a top photo with your crown area clearly visible — your doctor will assess scalp visibility and thinning.`,
      },
    },
    HairfallPhoto: {
      female: {
        title: $localize`:@@quizHairFrontPhotoTitleFemale:Now, we will check your front hairline`,
        subText: $localize`:@@quizHairFrontPhotoSubTextFemale:Take a front photo showing your hairline clearly — helps us accurately assess hair recession.`,
      },
      male: {
        title: $localize`:@@quizHairFrontPhotoTitleMale:Now, we will check your front hairline`,
        subText: $localize`:@@quizHairFrontPhotoSubTextMale:Take a front photo showing your hairline clearly — helps us accurately assess hair recession.`,
      },
    },
  };
}
